"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useRouting_1 = __importDefault(require("../../hooks/useRouting"));
const useTracking_1 = __importDefault(require("../../hooks/useTracking"));
const styles_1 = require("./styles");
const Link = (_a) => {
    var { children, filter, href, forcedExternal, onClick, hitConfig, payload } = _a, props = __rest(_a, ["children", "filter", "href", "forcedExternal", "onClick", "hitConfig", "payload"]);
    const { interpolate, redirect } = (0, useRouting_1.default)();
    const { onTagClick } = (0, useTracking_1.default)();
    const finalHref = href ? interpolate(href.concat(filter && filter.length ? `?filter=${filter}` : '')) : href;
    const handleClick = (0, react_1.useCallback)((event) => {
        event.preventDefault();
        if (hitConfig && onTagClick)
            onTagClick(hitConfig);
        if (onClick)
            onClick(event);
        if (finalHref)
            redirect(finalHref, forcedExternal, payload);
    }, [hitConfig, forcedExternal, finalHref]);
    return ((0, jsx_runtime_1.jsx)(styles_1.BaseLink, Object.assign({ href: finalHref, onClick: handleClick }, props, { children: children })));
};
exports.default = Link;
